import './Filter.scss';
import './DriverReportFilter.scss';
import React, { useEffect, useState } from 'react';
// import { ValueType } from 'react-select/src/types';
import { useQuery, useLazyQuery } from '@apollo/client/react';
import { DateTimePicker } from '../_common';
import {
    GET_ALL_LOFAS,
    GET_ALL_REGIONS,
    GET_ALL_CUSTOMERS,
    GET_ALL_JOBS_WITH_FILTERS_AND_SEARCH,
    GET_ALL_CARRIERS_FILTER,
    GET_ALL_DRIVERS_BY_CARRIER,
} from '../../graphql/client/queries';
import {
    GetAllJobsWithFiltersAndSearch,
    GetAllJobsWithFiltersAndSearch_getAllJobsWithFiltersAndSearch as JobType,
    GetAllDriversByCarriers,
    GetAllDriversByCarriers_getAllDriversByCarriers as DriverData,
    GetAllRegions,
    GetAllRegions_getAllRegions as RegionType,
    GetAllRegions_getAllRegions_districts as DistrictType,
    GetAllCustomers,
    GetAllCustomers_getAllCustomers as CustomerType,
    GetAllCarriersFilter,
    GetAllCarriersFilter_getAllCarriersFilter as CarrierType,
    GetAllLofas,
    GetAllLofas_getAllLofas as LofaType,
} from '../../types/schemaTypes';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import useDriverReportValidation from '../DriverReport/useDriverReportValidation';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { MultiSelectDropdown } from '../_common/MultiSelectDropdown/MultiSelectDropdown';

library.add(fas);

interface Option {
    id: number | string;
    name: string | number;
}

interface Suggestion {
    id: string | number;
    name: string;
}

interface OptionType {
    label: string;
    value: string;
}

export const DriverReportFilter = (): React.ReactElement => {
    const [show, setShow] = useState(false);
    const initialDrivers: OptionType[] = [];
    const [driverFilters, setDrivers] = useState(initialDrivers);
    const initialJobs: OptionType[] = [];
    const [jobs, setJobs] = useState(initialJobs);
    const initialDistrictsnew: OptionType[] = [];
    const [districtsnew, setDistrictsNew] = useState(initialDistrictsnew);
    const customers: OptionType[] = [];
    const lofaFilters: OptionType[] = [];
    const carrierFilters: OptionType[] = [];
    const newregions: OptionType[] = [];
    const [GetAllJobsForCustomer, { data: jobsData, loading: jobsLoading }] = useLazyQuery<GetAllJobsWithFiltersAndSearch>(
        GET_ALL_JOBS_WITH_FILTERS_AND_SEARCH,
    );
    const [GetAllCarrierDrivers, { data: driverRegionData, loading: driverRegionLoading }] = useLazyQuery<GetAllDriversByCarriers>(
        GET_ALL_DRIVERS_BY_CARRIER,
    );
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);

    const { data: regionsData } = useQuery<GetAllRegions>(GET_ALL_REGIONS);
    const { data: lofasData } = useQuery<GetAllLofas>(GET_ALL_LOFAS);
    const { data: customersData } = useQuery<GetAllCustomers>(GET_ALL_CUSTOMERS);
    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);

    const {
        inputs,
        fieldErrors,
        handleInputChange,
        handleAutoCompleteChange,
        handleDateInputChange,
        handleDropdownChange,
        handleSubmit,
        resetFormState,
    } = useDriverReportValidation();

    useEffect(() => {
        if (jobsData && jobsData.getAllJobsWithFiltersAndSearch && !jobsLoading) {
            if (jobsData && jobsData.getAllJobsWithFiltersAndSearch) {
                if (jobsData.getAllJobsWithFiltersAndSearch.length === 0 && inputs.customerName !== '') {
                    //setCustomerJobError(customerJobText);
                } else {
                    //setCustomerJobError('');
                    const customerJobs: OptionType[] = [];
                    jobsData.getAllJobsWithFiltersAndSearch.forEach((element: JobType | null) => {
                        if (element != null && element.jobId != null) {
                            customerJobs.push({
                                value: element.jobId.toString(),
                                label: element.jobName ?? '',
                            });
                        }
                    });
                    setJobs(customerJobs);
                }
            }
        }
    }, [jobsData, jobsLoading]);
    useEffect(() => {
        if (driverRegionData && driverRegionData.getAllDriversByCarriers && !driverRegionLoading) {
            if (driverRegionData && driverRegionData.getAllDriversByCarriers) {
                if (driverRegionData.getAllDriversByCarriers.length === 0) {
                    //setCustomerJobError(customerJobText);
                } else {
                    //setCustomerJobError('');
                    const carrierDrivers: OptionType[] = [];
                    driverRegionData.getAllDriversByCarriers.forEach((element: DriverData | null) => {
                        if (element != null && element.id != null) {
                            carrierDrivers.push({
                                value: element.id.toString(),
                                label: element.name ?? '',
                            });
                        }
                    });
                    setDrivers(carrierDrivers);
                }
            }
        }
    }, [driverRegionData, driverRegionLoading]);
    if (regionsData?.getAllRegions) {
        regionsData.getAllRegions.forEach((element: RegionType | null) => {
            if (element != null && element.regionName != null) {
                newregions.push({
                    value: element.id.toString(),
                    label: element.regionName,
                });
            }
        });
    }

    const getRegionDistrictsNew = (regionId: number[]): void => {
        const districtsListNew: OptionType[] = [];
        setDistrictsNew(districtsListNew);
        (regionsData?.getAllRegions ?? []).forEach((element: RegionType | null) => {
            if (element != null && regionId.find(x => x === element.id) && element.districts != null) {
                (element.districts ?? []).forEach((element1: DistrictType | null) => {
                    if (element1 != null && element1.districtName != null) {
                        districtsListNew.push({
                            value: element1.id.toString(),
                            label: element1.districtName,
                        });
                    }
                });
            }
        });
        setDistrictsNew(districtsListNew);
    };

    if (customersData?.getAllCustomers) {
        customersData.getAllCustomers.forEach((element: CustomerType | null) => {
            if (element != null && element.customerName != null && element.id != null) {
                customers.push({
                    value: element.id.toString(),
                    label: element.customerName,
                });
            }
        });
    }

    if (carriersData?.getAllCarriersFilter) {
        carriersData.getAllCarriersFilter.forEach((element: CarrierType | null) => {
            if (element != null && element.name != null && element.id != null) {
                carrierFilters.push({
                    value: element.id.toString(),
                    label: element.name,
                });
            }
        });
    }
    if (lofasData?.getAllLofas) {
        lofasData.getAllLofas.forEach((item: LofaType | null) => {
            if (item != null && item.lofaId != null && item.lofaName != null) {
                lofaFilters.push({
                    value: item.lofaId.toString(),
                    label: item.lofaName,
                });
            }
        });
    }
    const onRegionChangeNew = (selectedRegion: OptionType): void => {
        const selectedRegionIds: number[] = [];
        if (selectedRegion && selectedRegion !== null && Array.isArray(selectedRegion)) {
            for (let i = 0; i < selectedRegion.length; i++) {
                selectedRegionIds.push(parseInt(selectedRegion[i].value));
            }
        }
        getRegionDistrictsNew(selectedRegionIds);
    };

    const handleDissmis = (): void => {
        setShow(false);
        setIsSaveDisabled(false);
        //resetFormState();
    };
    const updateJobs = (selectedCustomer: OptionType): void => {
        const selectedcustomerIds: number[] = [];
        if (selectedCustomer && selectedCustomer !== null && Array.isArray(selectedCustomer)) {
            for (let i = 0; i < selectedCustomer.length; i++) {
                selectedcustomerIds.push(parseInt(selectedCustomer[i].value));
            }
            GetAllJobsForCustomer({
                variables: { input: { customerIds: selectedcustomerIds } },
            });
        } else {
            const customerJobs: OptionType[] = [];
            setJobs(customerJobs);
        }
        setIsSaveDisabled(false);
    };

    const updateDrivers = (selectedCarrier: OptionType): void => {
        const selectedcarrierIds: number[] = [];
        if (selectedCarrier && selectedCarrier !== null && Array.isArray(selectedCarrier)) {
            for (let i = 0; i < selectedCarrier.length; i++) {
                selectedcarrierIds.push(parseInt(selectedCarrier[i].value));
            }
            GetAllCarrierDrivers({
                variables: { input: { carrierIds: selectedcarrierIds } },
            });
        } else {
            const carrierDrivers: OptionType[] = [];
            setDrivers(carrierDrivers);
        }
        setIsSaveDisabled(false);
    };

    return (
        <div className="DriverFilter-Form">
            <div className="AddJob-Job-Profile-Title">Filters</div>
            <div className="DriverFilter-FormContainer">
                <Row>
                    <Col md={2} className="AddJob-Region-Container">
                        <MultiSelectDropdown
                            dropdownOptions={newregions}
                            label="REGION"
                            onChange={(value: OptionType): void => {
                                onRegionChangeNew(value);
                            }}
                        />
                    </Col>
                    <Col md={2} className="AddJob-Region-Container">
                        <MultiSelectDropdown
                            dropdownOptions={districtsnew}
                            label="DISTRICT"
                            key={JSON.stringify(districtsnew)}
                        />
                    </Col>
                    <Col md={4} className="AddJob-Region-Container">
                        <MultiSelectDropdown
                            dropdownOptions={customers}
                            label="Customer"
                            onChange={(value: OptionType): void => {
                                updateJobs(value);
                            }}
                        />
                    </Col>
                    <Col md={4} className="AddJob-Region-Container">
                        <MultiSelectDropdown dropdownOptions={jobs} label="Jobs" key={JSON.stringify(jobs)} />
                    </Col>
                </Row>
                <Row>
                    <Col md={4} className="AddJob-Region-Container">
                        <MultiSelectDropdown
                            dropdownOptions={carrierFilters}
                            label="Carrier"
                            onChange={(value: OptionType): void => {
                                updateDrivers(value);
                            }}
                        />
                    </Col>
                    <Col md={4} className="AddJob-Region-Container">
                        <MultiSelectDropdown
                            dropdownOptions={driverFilters}
                            label="Driver"
                            key={JSON.stringify(driverFilters)}
                        />
                    </Col>
                    <Col md={4} className="AddJob-Region-Container">
                        <MultiSelectDropdown dropdownOptions={lofaFilters} label="Lofa" />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <DateTimePicker
                            dateOnly
                            label="START DATE"
                            value={inputs.startDate}
                            onChange={(value: any) => {
                                handleDateInputChange('startDate', value);
                            }}
                            error={fieldErrors.startDateError || ''}
                        />
                    </Col>
                    <Col md={2}>
                        <DateTimePicker
                            dateOnly
                            label="END DATE"
                            value={inputs.endDate}
                            onChange={(value: any) => {
                                handleDateInputChange('endDate', value);
                            }}
                            error={fieldErrors.endDateError || ''}
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
};
